import * as R from 'ramda';

export const challengeIdsSelector = R.path(['content', 'challengeIds']);
export const challengesSelector = R.path(['content', 'challenges']);
export const challengesErrorSelector = R.path(['content', 'challengesError']);
export const challengesFetchedSelector = R.path(['content', 'challengesFetched']);
export const featuresSelector = R.path(['content', 'features']);
export const featuresFetchedSelector = R.path(['content', 'featuresFetched']);
export const orderedBySelector = R.path(['content', 'orderedBy']);
